import { useMemo } from 'react';
import { RequisitionStatus } from '../pages/ReviewDetails/RequisitionDetailsUtils';
import { canCreateRequisitionCart } from './authorization';
import { StoreOperations, StoreSubjects } from '../constants/constants';
import { useAppAbility, useCurrentUser } from '@gsa/afp-shared-ui-utils';
import { UserRoles } from '../constants';

export const canEditInReview = (ability, requistion, currentUser) => {
  const canCreateRequisition = canCreateRequisitionCart(ability);

  return (
    canCreateRequisition &&
    (requistion?.requisitionStatus === RequisitionStatus.DRAFT ||
      requistion?.requisitionStatus === RequisitionStatus.RETURNED) &&
    (requistion?.createdByUser === currentUser.id ||
      requistion?.createdByInfo?.id === currentUser.id)
  );
};

export const canEditAREQ = (requistion) => {
  const ability = useAppAbility();
  const { currentUser } = useCurrentUser();
  const isAdmin = useMemo(
    () => ability?.can(StoreOperations.Manage, StoreSubjects.All),
    [ability],
  );

  const isContractingOfficer = currentUser?.roles?.some(
    (role) => role.name === UserRoles.CONTRACTING_OFFICER,
  );
  const isOrderingAdmin = currentUser?.roles?.some(
    (role) => role.name === UserRoles.ORDERING_ADMIN,
  );

  const isDraftOrReturned =
    requistion?.requisitionStatus === 'DRAFT' ||
    requistion?.requisitionStatus === 'RETURNED';
  const isAREQ = requistion?.requisitionType === 2 && isDraftOrReturned;

  return isAREQ && (isAdmin || isOrderingAdmin || isContractingOfficer);
};
